<template>
  <a-menu
      slot="overlay">
    <a-menu-item key="download" @click="onDownloadClick" v-if="canDownload">
      <download-icon></download-icon>
      Downloaden
    </a-menu-item>
    <a-menu-item key="copy" @click="onCopyClick">
      <content-copy-icon></content-copy-icon>
      Kopieer naar
    </a-menu-item>
    <a-menu-item key="move" @click="onMoveClick">
      <content-cut-icon></content-cut-icon>
      Verplaats naar
    </a-menu-item>
    <a-menu-item key="edit" @click="onEditClick" v-if="canEdit">
      <pencil-icon></pencil-icon>
      Bewerken
    </a-menu-item>
    <a-menu-divider/>
    <a-menu-item key="delete" @click="onDeleteClick">
      <delete-icon></delete-icon>
      Verwijderen
    </a-menu-item>
  </a-menu>
</template>

<script>

export default {
  name: "AttachableMenuComponent",
  props: {
    attachable: {
      type: Object,
      required: true
    },
  },
  data() {
    return {}
  },
  computed: {
    childInstance() {
      return this.attachable.child_instance.data;
    },
    canShow() {
      return typeof this.childInstance.show_link !== "undefined";
    },
    showLink() {
      return this.childInstance.show_link;
    },
    canEdit() {
      return typeof this.childInstance.edit_link !== "undefined";
    },
    editLink() {
      return this.childInstance.edit_link;
    },
    canDownload() {
      return typeof this.childInstance.download_link !== "undefined";
    },
    downloadLink() {
      return this.childInstance.download_link;
    },
  },
  methods: {
    onDownloadClick() {
      this.$emit('download');
    },
    onCopyClick() {
      this.$emit('copy');
    },
    onMoveClick() {
      this.$emit('move');
    },
    onDeleteClick() {
      this.$emit('delete');
    },
    onEditClick(e) {
      this.$emit('edit');
    },
  }
}
</script>